import React, { createContext, useContext, useMemo } from 'react';

const EvalContext = createContext();

export const useEval = () => {
  const context = useContext(EvalContext);
  if (!context) {
    throw new Error('useEval must be used within an EvalProvider');
  }
  return context;
};

export const EvalProvider = ({ children }) => {
  const evalSteps = useMemo(
    () => [{ label: 'Dashboard', enabled: true }],
    []
  );

  const value = {
    evalSteps,
  };

  return (
    <EvalContext.Provider value={value}>
      {children}
    </EvalContext.Provider>
  );
};
